import { Divider, Popover } from 'antd';
import { WorkOrderItemData } from '..';
import { AlertTriangle } from 'react-feather';
import { isAppPortocar } from '@/index';

interface Props {
  workOrderItem: WorkOrderItemData;
}

export default function WorkOrderItemBenefitCostAlert({
  workOrderItem,
}: Props) {
  if (
    !isAppPortocar ||
    workOrderItem.unitCost > 0 ||
    !workOrderItem.benefitMaterialId ||
    !workOrderItem.isInternal
  )
    return null;

  return (
    <>
      <Popover
        content={
          <div style={{ width: 250 }}>
            Preencha o preço de custo da peça para composição da nota fiscal
            para o fabricante
          </div>
        }
      >
        <div>
          <AlertTriangle color="orange" size={20} />
        </div>
      </Popover>

      <Divider type="vertical" />
    </>
  );
}
